import { Files } from '../../lib/constants/files'
import { TransportMeanInput } from '../../lib/types/models/transport-means/transport-means-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createTransportMean(data: TransportMeanInput) {
  const { picto, ...rest } = data
  const s3Picto = await uploadFile(Files.TRANSPORT_MEAN_PICTO, picto)
  return restApiClient.url(constructApiUrl(API.transportMeans.create.url, null)).post({
    ...rest,
    picto: s3Picto
  })
}
